import React, { useContext, useState } from "react";
import PageHeader from "../../Component/PageHeader";
import CardSalesPcrLinksList from "../../Component/Card/Sales/SalesPcrLInks/CardSalesPcrLinksList";
import LayerFunctional from "../../LayerFunctional";
import MainContext from "../../Context/MainContext/MainContext";
import ChipLocation from "../../Component/Chip/ChipLocation";
import DialogSearchLocation from "../../Component/Dialog/Search/DialogSearchLocation";
import Location from "../../Utility/Crud/Location";
import User from "../../Utility/Crud/User";
import Setting from "../../Utility/Setting";
import MUIEditIcon from "@mui/icons-material/Edit";
import MUIToggleButton from "@mui/material/ToggleButton";
import MUIToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import MUIStack from "@mui/material/Stack";
/**
 * New PCR Links workspace (starter). The legacy admin list remains at
 * /admin/salesPcrLinks (AdminSalesPcrLinkList).
 */
export default function PcrLinks() {
    const locationSettingKey = "salesPcrLinks.prefilters.locationIds";
    const mainContext = useContext(MainContext);
    const [mode, setMode] = useState("PCR");
    const [locationDialogOpen, setLocationDialogOpen] = useState(false);
    const [selectedLocationIds, setSelectedLocationIds] = useState(null);

    const filteredLocations = User.getFilteredLocations(
        mainContext.currentUser,
        mainContext.userprofileLocationsIndexed,
        mainContext.locationsIndexed
    );
    const filteredLocationIds = filteredLocations.map((location) => location.id);
    const settingLocationIds = (Setting.get(locationSettingKey) || []).filter((locationId) => {
        return filteredLocationIds.includes(locationId);
    });
    const activeSelectedLocationIds = selectedLocationIds !== null
        ? selectedLocationIds
        : (settingLocationIds.length > 0 ? settingLocationIds : filteredLocationIds);

    // Returns the maximum width in pixels for the LayerFunctional component.
    const getMaxWidth = () => {
        return 1000;
    }

    // Renders the page header for the Sales PCR Links workspace.
    const renderHeader = () => {
        const nameLimit = 25;
        let locationDisplayNames = activeSelectedLocationIds
            .slice(0, nameLimit)
            .map((locationId) => Location.getDisplayName(mainContext.locationsIndexed[locationId]))
            .filter(Boolean)
            .join("\n");
        const moreLocationsCount = activeSelectedLocationIds.length - nameLimit;
        locationDisplayNames = moreLocationsCount > 0
            ? `${locationDisplayNames}\n+ ${moreLocationsCount.toLocaleString()} more`
            : locationDisplayNames;

        const buttons = [
            <React.Fragment key="location-prefilter">
                <MUIStack direction="row" alignItems="center">
                    <ChipLocation
                        location={activeSelectedLocationIds.length === 1 ? mainContext.locationsIndexed[activeSelectedLocationIds[0]] : null}
                        nullLabel={activeSelectedLocationIds.length > 1 ? `Locations (${activeSelectedLocationIds.length})` : `My Locations (${filteredLocations.length.toLocaleString()})`}
                        tooltip={locationDisplayNames}
                        onClick={filteredLocations.length > 1 ? (() => { setLocationDialogOpen(true); }) : null}
                        onDelete={filteredLocations.length > 1 ? (() => { setLocationDialogOpen(true); }) : null}
                        deleteIcon={<MUIEditIcon />}
                    />
                </MUIStack>
                <DialogSearchLocation
                    data={filteredLocations}
                    open={locationDialogOpen}
                    onClose={() => setLocationDialogOpen(false)}
                    onSelect={(locations) => {
                        const locationIds = locations.map((location) => location.id);
                        setSelectedLocationIds(locationIds);
                        Setting.set(locationSettingKey, locationIds);
                    }}
                    onClear={() => {
                        setSelectedLocationIds(filteredLocationIds);
                        setLocationDialogOpen(false);
                        Setting.clear(locationSettingKey);
                    }}
                    multiSelect={true}
                    selected={
                        Location.read(
                            mainContext.locationsIndexed,
                            [
                                {
                                    key: "id",
                                    value: activeSelectedLocationIds
                                }
                            ]
                        )
                    }
                />
            </React.Fragment>,
            (
                <MUIToggleButtonGroup
                    key="mode-toggle"
                    exclusive={true}
                    size="small"
                    value={mode}
                    onChange={(_, newMode) => {
                        if (newMode !== null) {
                            setMode(newMode);
                        }
                    }}
                    // TODO: Drop shadow, hover color, hover transition
                    sx={{
                        "& .MuiToggleButton-root": {
                            minWidth: "110px",
                            borderColor: "primary.main",
                            color: "primary.main",
                            height: 40,
                        },
                        "& .MuiToggleButton-root.Mui-selected": {
                            backgroundColor: "primary.main",
                            color: "primary.contrastText",
                        },
                        "& .MuiToggleButton-root.Mui-selected:hover": {
                            backgroundColor: "primary.dark",
                        },
                    }}
                >
                    <MUIToggleButton value="PCR">PCR/ATP</MUIToggleButton>
                    <MUIToggleButton value="Sales">Sales Rep</MUIToggleButton>
                </MUIToggleButtonGroup>
            ),
        ].filter(Boolean);

        return <PageHeader title="PCR Links" buttons={buttons} />;
    }

    // Renders the main content, which is the Sales PCR links list card component.
    const renderContent = () => {
        return <CardSalesPcrLinksList mode={mode} selectedLocationIds={activeSelectedLocationIds} />;
    }

    return (
        <LayerFunctional getMaxWidth={getMaxWidth} renderHeader={renderHeader} renderContent={renderContent} />
    );
}
